import { Stack } from '@mui/material';

import ConceptsFileUpload from './ConceptsFileUpload';
import ConceptsUploadInstructions from './ConceptsUploadInstructions';

interface ConceptsUploadStepProps {
  selectedFile: File | null;
  onFileSelect: (file: File) => void;
  isLoading?: boolean;
}

export const ConceptsUploadStep = ({
  selectedFile,
  onFileSelect,
  isLoading,
}: ConceptsUploadStepProps) => {
  return (
    <Stack width={'840px'} direction={'column'} gap={'24px'}>
      <ConceptsUploadInstructions />
      <ConceptsFileUpload
        selectedFile={selectedFile}
        onFileSelect={onFileSelect}
        isLoading={isLoading}
      />
    </Stack>
  );
};
